<template>
  <v-card class="total-row" flat>
    <div class="row">
      <div class="col-12">
        <span class="total-row__total q-ml-md">
          Skupaj:
        </span>
        <span class="total-row__total" :inner-html.prop="total | price(2)">
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    total: {
      required: true,
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>

.total-row {
  padding: 15px;
  margin: 5px;
  margin-bottom: 15px;

  &__total {
    padding-right: 20px;
    font-size: 25px;
    font-weight: bold;
  }
}
</style>
